import classNames from 'classnames';
import { useTranslations } from 'next-intl';

import { IPlans } from 'modules/pro';

interface IProps {
  plan: IPlans;
  selected: boolean;
  onSelect: () => void;
}

export const PlanOption: React.FC<IProps> = ({ plan, selected, onSelect }) => {
  const t = useTranslations();

  return (
    <div
      onClick={onSelect}
      className={classNames(`relative cursor-pointer rounded-2xl p-0.5 transition`, {
        'from-green-450 to-blue-450 bg-gradient-to-br': selected,
        'bg-transparent': !selected
      })}
    >
      <div
        className={classNames(`rounded-14 flex items-center justify-between p-4`, {
          'bg-green-50': selected,
          'bg-gray-100': !selected
        })}
      >
        <div className="flex items-center gap-3.5">
          <div
            className={classNames('flex h-5 w-5 items-center justify-center rounded-full p-1', {
              'from-green-450 to-blue-450 bg-gradient-to-br': selected,
              'bg-gray-300': !selected
            })}
          >
            <div
              className={classNames('flex items-center justify-center rounded-full p-0.5', {
                'bg-white': selected,
                'bg-gray-100': !selected
              })}
            >
              <div
                className={classNames(`h-3 w-3 rounded-full`, {
                  'from-green-450 to-blue-450 bg-gradient-to-br': selected,
                  'bg-transparent': !selected
                })}
              />
            </div>
          </div>
          <p className="font-semibold text-gray-900">
            {plan?.month_count} {t('oylik')}
          </p>
        </div>

        <div className="flex items-center gap-3 text-right">
          {plan?.discount_price > 1 ? (
            <div className="flex items-center justify-end gap-2">
              <span className="text-xs text-red-600 line-through sm:text-sm">
                {plan?.discount_price?.toLocaleString('ru')} {t('sum')}
              </span>
              {plan?.discount_percent && (
                <span className="from-green-450 to-blue-450 absolute -top-2 right-2 rounded-md bg-gradient-to-br px-1 py-0.5 text-xs font-medium text-white">
                  -{Math.floor(plan?.discount_percent)}%
                </span>
              )}
            </div>
          ) : null}
          <p className="font-bold text-gray-900">
            {plan?.price?.toLocaleString('ru')} {t('sum')}
          </p>
        </div>
      </div>
    </div>
  );
};
